module.exports = __webpack_public_path__ + "static/media/statistiche.fd04285a.svg";